import { Fragment } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Palette } from "@phosphor-icons/react";

import { SectionHeader } from "@/components/brand-intelligence/layout/heading";
import { VerbalIdentity } from "@/components/card/brand-intelligence/verbal-identity";
import { VisualIdentity } from "@/components/card/brand-intelligence/visual-identity";
import { CreativeAssets } from "@/components/card/brand-intelligence/creative-assets";
import { AICreativeMemory } from "@/components/card/brand-intelligence/ai-creative-memory";
import { Compliance } from "@/components/card/brand-intelligence/compliance";

export const Route = createFileRoute("/dashboard/research/_layout/$id/creative")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Fragment>
      <SectionHeader title="Creative System" icon={<Palette className="text-destructive size-6" />} iconClassName="bg-destructive/10" />
      <div className="space-y-6">
        <VisualIdentity />
        <VerbalIdentity />
        <CreativeAssets />
        <AICreativeMemory />
        <Compliance />
      </div>
    </Fragment>
  );
}
